module.exports = __webpack_public_path__ + "static/assets/19c8576de2ccf868f2cbc7dac3d0ee7e.png";